import React from 'react';
import Table from './Table';

const Bills = ({ bills }) => (
    <div className="row">
        <div className="col">
            <div className="card shadow mb-5">
                <div className="card-header border-0">
                    <h3 className="mb-0">Boletos e Guias Gerados</h3>
                </div>
                <div className="table-responsive">
                    <Table bills={bills} />
                </div>
            </div>
        </div>
    </div>
);

export default Bills;


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Bills/index.js